import { BodyRenderExternalData } from '~/components/BodyRender/models';
import { SitemapListProps } from '~/components/SitemapList/models';

import { SitemapBlock } from './models';

export const sitemapMapper = (
  {
    entryTitleField,
    mainLevel,
    sublistSecondLevel,
    sublistFirstLevel,
    componentId,
  }: SitemapBlock,
  _currentPageUid: string,
  { locale }: BodyRenderExternalData
): SitemapListProps => ({
  entryTitleField,
  mainLevel,
  sublistSecondLevel,
  sublistFirstLevel,
  locale: locale!,
  componentId,
});
